import {
  BrowserRouter,
  Routes as DOMRoutes,
  Navigate,
  Route,
} from "react-router-dom";

import AdminLayout from "Styles/Layouts/AdminLayout";
import AuthLayout from "Styles/Layouts/AuthLayout";
import NoAuthLayout from "Styles/Layouts/NoAuthLayout";
import AdminTheme from "Styles/Themes/admin";

import UseAuth from "Hooks/UseAuth";

import AdminRoutes from "./Components/Admin";
import AuthRoutes from "./Components/Auth";
import GlobalRoutes from "./Components/Global";
import NoAuthRoutes from "./Components/NoAuth";

const Routes = ({ setTheme }) => {
  const { parsedJWT, filterRoutes } = UseAuth();

  return (
    <BrowserRouter>
      {window.location.pathname === NoAuthRoutes.AdminLogin.path &&
        setTheme(AdminTheme)}
      <DOMRoutes>
        {Object.entries(NoAuthRoutes).map(([key, value]) => (
          <Route
            key={key}
            path={value.path}
            element={
              <NoAuthLayout {...value}>
                {<value.element {...value} />}
              </NoAuthLayout>
            }
          />
        ))}

        {Object.entries(AuthRoutes)
          .filter(([k, value]) => filterRoutes(value, parsedJWT, k))
          .map(([key, value]) => {
            return (
              <Route
                key={key}
                path={value.path}
                element={
                  <AuthLayout noHeader {...value}>
                    {<value.element {...value} />}
                  </AuthLayout>
                }
              />
            );
          })}

        {Object.entries(AdminRoutes).map(([key, value]) => (
          <Route
            key={key}
            path={value.path}
            element={
              <AdminLayout noHeader {...value}>
                {<value.element {...value} />}
              </AdminLayout>
            }
          />
        ))}

        {Object.entries(GlobalRoutes)
          .filter(([k, value]) => filterRoutes(value, parsedJWT, k))
          .map(([key, value]) => {
            return (
              <Route
                key={key}
                path={value.path}
                element={<value.element {...value} />}
              />
            );
          })}

        <Route
          path="*"
          element={<Navigate to={AuthRoutes.Dashboard.path} replace />}
        />
      </DOMRoutes>
    </BrowserRouter>
  );
};

export default Routes;
